<div [formGroup]="defaultDateRangeGroup" class="section-content">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "app.defaultDisplayTimePeriod" | translate }}</mat-label>
    <mat-select
      formControlName="kind"
      (selectionChange)="onKindChange($event.value)"
      >
      <mat-option value="24h">{{ "app.timePeriodLast24Hours" | translate }}</mat-option>
      <mat-option value="7d">{{ "app.timePeriodLastWeek" | translate }}</mat-option>
      <mat-option value="14d">{{ "app.timePeriodLast2Weeks" | translate }}</mat-option>
      <mat-option value="1m">{{ "app.timePeriodLastMonth" | translate }}</mat-option>
      <mat-option value="1y">{{ "app.timePeriodLastYear" | translate }}</mat-option>
      <mat-option value="zero">{{ "app.timePeriodFromZeroMeasurement" | translate }}</mat-option>
      <mat-option value="custom">{{ "app.timePeriodSelectRange" | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  @if (defaultDateRangeGroup.get('kind')?.value === 'custom') {
    <div
      class="form-row"
      formGroupName="custom"
      >
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Startdatum</mat-label>
        <input matInput [matDatepicker]="pickerStart" formControlName="start" />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerStart"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Enddatum</mat-label>
        <input matInput [matDatepicker]="pickerEnd" formControlName="end" />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>
    </div>
  }
</div>
